import React from "react";
import * as Styled from "../../../CompanyForm.styled";
import NavBar from "../../elements/Navbar/NavBar";
import CustomTimeline from "../Timeline/Timeline";

export const DefaultLayout = ({
  children,
  currentStep,
  hideContinueButton = false,
}) => {
  return (
    <Styled.LayoutWrapper>
      <Styled.LayoutContainer>
        <Styled.TimelineWrapper>
          <CustomTimeline currentStep={currentStep} />
        </Styled.TimelineWrapper>

        <Styled.ContentWrapper>
          <Styled.NavbarWrapper>
            <NavBar
              hideContinueButton={hideContinueButton}
              currentStep={currentStep}
            />
          </Styled.NavbarWrapper>

          <Styled.BodyWrapper>
            {children}
          </Styled.BodyWrapper>
        </Styled.ContentWrapper>
      </Styled.LayoutContainer>
    </Styled.LayoutWrapper>
  );
};
